﻿module.exports = ['$uibModal', messageModal];

function messageModal($uibModal) {
    var modal = {
        dismiss: dismissModal,
        modalRef: null,
        show: showModal
    };

    messageModal.$inject = [
        '$uibModalInstance',
        'title',
        'message',
    ];

    function messageModalController(
        $uibModalInstance,
        title,
        message
    ) {

        var vm = {
            title: title,
            message: message,
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            $uibModalInstance.dismiss(true);
        }

        return vm;
    }

    function dismissModal() {

    }

    function showModal(
        title,
        message
    ) {

        return $uibModal.open({
            animation: true,
            backdrop: true,
            controller: messageModalController,
            controllerAs: '$ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                title: () => title,
                message: () => message,
            },
            templateUrl: 'widgets/modals/message.html'
        });
    }

    return modal;
}
